// extracted by mini-css-extract-plugin
export default {"backdrop":"modal_backdrop__2MS+F","modal":"modal_modal__vXKzK","heading":"modal_heading__QNe+I","title":"modal_title__9E9HP","closeIcon":"modal_closeIcon__qpEH8"};